import classNames from 'classnames';
import React, { ChangeEvent, useCallback, useState } from 'react';
import { useIntl } from 'react-intl';

import LabeledContainer from '../../../../common/LabeledContainer';
import FormErrorMessage from '../../../../../atoms/FormErrorMessage';
import TextInput, { TextInputType } from '../../../../../atoms/TextInput';
import { BookingPageRepositoryForSSR } from '../../../../../infrastructure/repositories/BookingPageRepository';

import secretImage from '../../../../../../public/static/books/secret.png';

import css from './MerchantCourseDetailsPageProtected.module.scss';
import { RSButton } from 'src/reservation-page/RSButton';

interface Props {
  session: string;
  token: string;
  requestId: string;
  publicId: string;
  servicePublicId: string;
  onSubmit: (result: boolean) => void;
}

const MerchantCourseDetailsPageProtected: React.FC<Props> = ({
  session,
  token,
  requestId,
  publicId,
  servicePublicId,
  onSubmit,
}) => {
  const intl = useIntl();
  const [posting, setPosting] = useState<boolean>(false);
  const [password, setPassword] = useState<string>('');
  const [posted, setPosted] = useState<boolean>(false);
  const [result, setResult] = useState<boolean>(false);

  const handleChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    setPassword(e.currentTarget.value);
  }, []);

  const handleSubmit = async () => {
    setPosting(true);

    const verifyResult = await BookingPageRepositoryForSSR(
      session,
      token,
      requestId,
    ).PasswordVerify(publicId, servicePublicId, password);

    setPosted(true);
    setPosting(false);
    setResult(verifyResult);
    onSubmit(verifyResult);
  };

  const classes = classNames(css.MerchantCourseDetailsPageProtected);

  return (
    <div className={classes}>
      <img
        className={css.MerchantCourseDetailsPageProtected__Img}
        src={secretImage}
        alt=""
      />
      <dl className={css.MerchantCourseDetailsPageProtected__Notes}>
        <dt className={css.MerchantCourseDetailsPageProtected__Heading}>
          {intl.formatMessage({ id: 'merchants.secret.notes.heading' })}
        </dt>
        <dd className={css.MerchantCourseDetailsPageProtected__Description}>
          {intl.formatMessage({
            id: 'merchants.secret.notes.description',
          })}
        </dd>
      </dl>
      <div className={css.MerchantCourseDetailsPageProtected__Password}>
        <LabeledContainer
          label={intl.formatMessage({ id: 'merchants.secret.password' })}
          errorStyle={posted && !result}
        >
          <TextInput
            type={TextInputType.Password}
            value={password}
            // @ts-expect-error strictFunctionTypes
            onChange={handleChange}
          />
        </LabeledContainer>
        {posted && !result && (
          <FormErrorMessage>
            {intl.formatMessage({ id: 'merchants.secret.errorMessages' })}
          </FormErrorMessage>
        )}
      </div>
      <div className="flex justify-center px-[18px] py-2.5">
        <div className="min-w-[164px]">
          <RSButton
            variant="basic"
            isBlock
            isLoading={posting}
            disabled={!password || posting}
            value={intl.formatMessage({
              id: 'books.submitLabel.ok',
            })}
            onClick={handleSubmit}
          >
            {intl.formatMessage({
              id: 'books.submitLabel.ok',
            })}
          </RSButton>
        </div>
      </div>
    </div>
  );
};

export default MerchantCourseDetailsPageProtected;
